import type { ChatFile } from "./chat.type";
import type { CoreEntity } from "./core";

export enum MessageRole {
  User = "USER",
  Assistant = "ASSISTANT",
}

export interface ChunkResult {
  text: string;
  source: string;
  page?: number | null;
  score: number;
}

export interface FileAttach extends CoreEntity {
  fileName: string;
  originalName: string;
  fileSize: number;
  mimeType: string;
  filePath: string;
}

export interface Message extends CoreEntity {
  content: string;
  role: MessageRole;
  sources?: ChunkResult[] | null;
  fileAttaches?: FileAttach[]; // tu api message
  files?: ChatFile[]; // cai nay de submit
}

export type SseEventType = "sources" | "token" | "done" | "error" | "title";

export interface SseEvent {
  type: SseEventType;
  data: unknown;
}

export interface ChatStreamResult {
  content: string;
  sources: ChunkResult[];
  messageId: number;
}
